var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_108_290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_108_290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6702 7.84582L14.0414 13.3658L14.2257 16.1402C14.2277 16.4255 14.2723 16.709 14.3586 16.9814C14.5811 17.5102 15.1166 17.8462 15.6991 17.8227L24.5754 17.242C24.9598 17.2358 25.331 17.3795 25.6073 17.6418C25.8375 17.8603 25.9862 18.1462 26.0331 18.4536L26.0489 18.6403C25.6815 23.7266 21.9459 27.969 16.8702 29.064C11.7944 30.1591 6.58947 27.8458 4.08127 23.3799C3.35818 22.0824 2.90652 20.6564 2.75283 19.1854C2.68863 18.7499 2.66036 18.31 2.6683 17.87C2.66036 12.417 6.54362 7.70265 11.9794 6.56613C12.6337 6.46425 13.275 6.8106 13.5374 7.40741C13.6053 7.54562 13.6501 7.69365 13.6702 7.84582Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.3337 13.083L29.3244 13.1265L29.2975 13.1897L29.3012 13.3632C29.2873 13.5929 29.1985 13.814 29.0457 13.9926C28.8864 14.1786 28.6688 14.3053 28.4292 14.3545L28.2831 14.3745L18.042 15.0381C17.7013 15.0717 17.3621 14.9618 17.1089 14.736C16.8977 14.5476 16.7628 14.2934 16.7247 14.0196L16.0373 3.79337C16.0253 3.7588 16.0253 3.72132 16.0373 3.68673C16.0467 3.40485 16.1708 3.13841 16.3819 2.94693C16.5928 2.75545 16.8733 2.65489 17.1604 2.66772C23.2403 2.8224 28.3501 7.19435 29.3337 13.083Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.b130f54eaffd2a096f943ae131deefd7.svg";
export { ForwardRef as ReactComponent };